import React from "react";
import { MainLayout } from "../../MainLayout";
import { KenyaSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";
export const Kenya = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/delhi-air.png",
            sliderimg: [
                {
                    id: 1,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/zebraaa.webp",
                    title: "Maasai Mara Wildlife Safari",
                },
                {
                    id: 2,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/mammal.webp",
                    title: "Maasai Mara Wildlife Safari",
                },
            ],
            title: "4N/5D Kenya Explorer",
            days: "4N/5D",
            tags: ["Bird Haven", "Lakes", "WildLife"],
            description:
                "This 4-night Kenya itinerary offers adventure and relaxation, beginning in Nairobi with leisure time at the hotel. Day 2 takes you to Lake Naivasha or Lake Elementaita for a scenic boat ride and optional nature walks. The highlight is the Maasai Mara on Days 3 and 4, featuring thrilling game drives, wildlife encounters, and cultural experiences. The trip concludes on Day 5 with a return to Nairobi and optional last-minute city exploration before departure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/safari.webp",
            slug: "fiveKenyan",
        },

        {
            title: "6N/7D Best of Kenya",
            days: "6N/7D",
            tags: ["Mountain", "Lakes", "WildLife"],
            description:
                "This 6-night Kenya itinerary covers Nairobi, Amboseli, Lake Naivasha/Elementaita, and Maasai Mara, offering a mix of adventure and relaxation. It begins with leisure time in Nairobi before heading to Amboseli for thrilling game drives with views of Mount Kilimanjaro. Next, visitors explore Lake Naivasha or Elementaita, enjoying scenic boat rides and birdwatching. The journey ends with an unforgettable wildlife experience in Maasai Mara, featuring multiple game drives and optional cultural visits, before returning to Nairobi for departure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/safari.webp",
            slug: "sevenKenyan",
        },

        {
            title: "7N/8D Luxury Kenya",
            days: "7N/8D",
            tags: ["Safari", "Lakes", "Bird Haven"],
            description:
                "This 7-night high-end Kenya itinerary offers a luxurious safari experience across Nairobi, Meru, Lake Elementaita, and Maasai Mara. It begins with relaxation in Nairobi before heading to Meru for immersive game drives and breathtaking landscapes. The journey continues to Lake Elementaita for scenic views and ends in Maasai Mara, where travelers enjoy thrilling wildlife encounters, optional hot air balloon safaris, and the iconic Big Five sightings. The trip concludes with a return to Nairobi before departure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/lake.webp",
            slug: "eightKenya1",
        },

        {
            title: "7N/8D Kenya Wonders",
            days: "7N/8D",
            tags: ["Meals", "Lakes", "WildLife"],
            description:
                "This 7-night Kenya itinerary offers a mix of adventure and relaxation, covering Nairobi, Amboseli, Lake Elementaita/Naivasha, and Maasai Mara. It starts with a comfortable stay in Nairobi before heading to Amboseli for game drives and stunning views of Mount Kilimanjaro. The journey continues to Lake Elementaita/Naivasha for birdwatching and nature walks, followed by thrilling wildlife safaris in Maasai Mara, home to the Big Five. The trip ends with a return to Nairobi for a final city exploration before departure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/circuit.webp",
            slug: "eightKenya2",
        },

        {
            title: "7N/8D Kenya Wild Escape",
            days: "7N/8D",
            tags: ["Meals", "Lakes", "WildLife"],
            description:
                "This 7-night Kenya bush itinerary offers a perfect mix of adventure and relaxation, covering Nairobi, Amboseli, Lake Elementaita, and Maasai Mara. It begins with a stay in Nairobi before heading to Amboseli for thrilling game drives and breathtaking views of Mount Kilimanjaro. The journey continues to Lake Elementaita for serene landscapes before culminating in Maasai Mara, where travelers experience abundant wildlife and optional activities like hot air balloon safaris. The trip concludes with a return to Nairobi for a relaxing evening before departure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/kenyawild.webp",
            slug: "eightKenya3",
        },

        {
            title: "7N/8D Safari & Serenity",
            days: "7N/8D",
            tags: ["Safari", "Lakes", "WildLife"],
            description:
                "This 7-night Kenya itinerary blends an exciting bush safari with a relaxing beach retreat. It starts in Nairobi, followed by thrilling game drives in Maasai Mara, where travelers witness abundant wildlife and the iconic Big Five. After a scenic stop at Lake Elementaita, the journey continues to Mombasa for sun-soaked beaches, cultural exploration, and optional marine adventures. The trip concludes with a leisurely coastal stay before departure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/kenyasafari.webp",
            slug: "eightKenya4",
        },

        {
            title: "3N/4D NAIROBI & AMBOSELI NATIONAL PARK",
            days: "3N/4D",
            tags: ["Safari", "Lakes", "WildLife"],
            description:
                "This 3-night Kenya itinerary blends an exciting bush safari with a relaxing beach retreat. It starts in Nairobi, followed by thrilling game drives in Maasai Mara, where travelers witness abundant wildlife and the iconic Big Five. After a scenic stop at Lake Elementaita, the journey continues to Mombasa for sun-soaked beaches, cultural exploration, and optional marine adventures. The trip concludes with a leisurely coastal stay before departure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/amb.webp",
            slug: "eightKenya5",
        },

        {
            title: "3N/4D NAIROBI & MASAI MARA",
            days: "3N/4D",
            tags: ["Safari", "Lakes", "WildLife"],
            description:
                "This 3-night Kenya itinerary combines the vibrant energy of Nairobi with the wild beauty of the Masai Mara. Begin your journey in Nairobi, exploring local culture and iconic landmarks before heading into the heart of safari country.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/masa.webp",
            slug: "eightKenya6",
        },
    ];

    const topcitydata = [
        {
            id: 1,
            title: "Nairobi",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/nairobi.webp",
            desc: [
                <p>
                    <strong> Why Visit:</strong> The capital and largest city of Kenya,
                    Nairobi is a bustling metropolis that offers a mix of urban excitement
                    and wildlife experiences. It's the only city in the world with a
                    national park (Nairobi National Park) just on its doorstep. Nairobi is
                    also the hub for many of Kenya's major businesses and a great starting
                    point for safaris or exploring East Africa.
                </p>,
                <p>
                    <strong>Top Attractions:</strong> Nairobi National Park, David
                    Sheldrick Wildlife Trust, Giraffe Centre, Karen Blixen Museum, Nairobi
                    Railway Museum, and vibrant markets and restaurants.
                </p>,
            ],
        },
        {
            id: 2,
            title: "Mombasa",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/mombasa.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Mombasa is Kenya's second-largest city and
                    the main coastal hub, known for its rich Swahili culture, stunning
                    beaches, and historical sites. The city offers a blend of modern and
                    colonial architecture, along with great seafood and beach resorts.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Fort Jesus, Mombasa Old Town, Diani
                    Beach, Nyali Beach, Haller Park, and the Mombasa Tusks.
                </p>,
            ],
        },
        {
            id: 3,
            title: "Kisumu",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/kisumu.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Located on the shores of Lake Victoria,
                    Kisumu is Kenya’s third-largest city and a key cultural and economic
                    center in western Kenya. The city has a laid-back vibe, with beautiful
                    lake views and various outdoor activities.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Kisumu Impala Sanctuary, Dunga Hill
                    Camp, Lake Victoria, Kisumu Museum, and the nearby Ruma National Park.
                </p>,
            ],
        },
        {
            id: 4,
            title: "Nakuru",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Nakuru.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Nakuru is a lively town in the Great Rift
                    Valley, known for its proximity to Lake Nakuru National Park, which is
                    famous for flamingos and wildlife, including rhinos. The city also
                    boasts a pleasant climate and scenic beauty, making it a great
                    getaway.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Lake Nakuru National Park, Menengai
                    Crater, Lake Elementaita, and the local craft markets.
                </p>,
            ],
        },
        {
            id: 5,
            title: "Eldoret",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/eldoret.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Eldoret is located in the western part of
                    Kenya and is a fast-growing city known for its agricultural
                    production, including tea and maize. The city has a relaxed atmosphere
                    and is popular for its sports culture, particularly long-distance
                    running.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Eldoret Town, Kimumu Market, the
                    Iten Athletics Camp, and scenic views of the surrounding countryside.
                </p>,
            ],
        },
        {
            id: 6,
            title: "Thika",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/thika.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Thika is an industrial city located about
                    40 kilometers from Nairobi. Known for its agriculture, especially
                    pineapple farming, Thika is also a gateway to various natural
                    attractions.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Thika Falls, Ol Donyo Sabuk National
                    Park, and the Fourteen Falls.
                </p>,
            ],
        },
        {
            id: 7,
            title: "Machakos",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Kenya%20Top%20places/machakos.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Situated just outside Nairobi, Machakos is
                    a popular spot for a relaxing getaway. The city is known for its
                    rolling hills, nice climate, and being a center for agricultural
                    production.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Machakos Peoples Park, Machaikon
                    Hill, and scenic views of the surrounding countryside.
                </p>,
            ],
        },
        {
            id: 8,
            title: "Malindi",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/malindi.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Malindi, located on the Kenyan coast, is
                    famous for its beautiful beaches, rich history, and vibrant Swahili
                    culture. The town is a popular destination for both tourists and
                    locals, offering a laid-back vibe, and it is close to Watamu and other
                    coastal attractions.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Malindi Marine National Park, Gede
                    Ruins, Watamu Beach, and the Malindi National Museum.
                </p>,
            ],
        },
        {
            id: 9,
            title: "Kisii",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/kisii.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Kisii is a lively town in western Kenya,
                    surrounded by lush hills and tea plantations. It is known for its
                    agricultural produce, particularly tea, and has a warm and welcoming
                    atmosphere.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Kisii Town, local tea farms, and
                    scenic views of the surrounding highlands.
                </p>,
            ],
        },
        {
            id: 10,
            title: "Lamu",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/lamu.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Lamu is a historic Swahili town on an
                    island off the Kenyan coast. It's one of the oldest towns in East
                    Africa, known for its preserved Swahili culture, narrow streets, and
                    beautiful beaches. It’s a UNESCO World Heritage site and a great place
                    to experience authentic Kenyan coastal life.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Lamu Old Town, Lamu Fort, Shela
                    Beach, and Lamu Museum.
                </p>,
            ],
        },
    ];

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Custom Kenya Itineraries",
            desc: "Your journey, your way—track the Great Migration, relax on the coast of Mombasa, or explore the scenic beauty of Kenya’s national parks."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Guided Safari Experiences",
            desc: "Explore Kenya’s wilderness with expert safari guides. From Maasai Mara to Amboseli, experience wildlife encounters with deep local insight."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Luxury Safari Lodges & Camps",
            desc: "Stay in world-class safari lodges and luxury tented camps where comfort meets the raw beauty of Africa’s wilderness."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Cultural Encounters",
            desc: "Connect with Kenya’s rich tribal heritage through Maasai village visits, traditional dance performances, and authentic local interactions."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Wildlife Safari Experiences",
            desc: "Witness the Big Five in their natural habitat across iconic parks like Maasai Mara, Tsavo, and Lake Nakuru National Park."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Adventure & Outdoor Experiences",
            desc: "From hot air balloon rides over the savannah to hiking Mount Kenya, experience adventure in Africa’s most iconic landscapes."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Beach & Coastal Escapes",
            desc: "Unwind along Kenya’s stunning coastline—Diani Beach, Mombasa, and Watamu offer pristine beaches and crystal-clear waters."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Spiritual & Authentic Local Experiences",
            desc: "Discover Kenya beyond safaris through local community visits, storytelling traditions, and immersive cultural journeys."
        },
    ];

    return (
        <>
            <MainLayout bgImage={
                'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/kenya%20main%20page%20banner.webp")'
            }
                text2={"Kenya"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={KenyaSec1Data} />
            <IndiaSec2 countryCode="KE" />
            <IndiaSec3 data={topcitydata} name={"Kenya"} />
            <IndiaSec4 data={data}
                heading={"Our Kenya Safari & Travel Experiences "}
            />
            <Footer />

        </>
    )


};